import React from 'react';
import ExpandMore from 'assets/expand-down.svg';
import ExpandUp from 'assets/expand-up.svg';
export const ExpandMoreIcon = () => <img alt="expandmore" src={ExpandMore}></img>;
export const ExpandUpIcon = () => <img alt="expandup" src={ExpandUp}></img>;
